const pageId = '251103';

export default {
  pageName: 'Weekly Report Version Performance',
  pageId,
  pagePath: '/opinion/CustomizedReports/WeeklyReport/VersionPerformance',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
};
